class PageLayoutModel extends App.Models.BaseModel {
    modelUrl = 'Order';
}

App.Models.PageLayout = PageLayoutModel;
